//Pages js for tabs
 document.addEventListener('DOMContentLoaded', function() {
    const tabsButtons = document.querySelectorAll('.nav-item');
    if(tabsButtons){
    const tabsContents = document.querySelectorAll('.tab-pane');
    const tabsBack = document.querySelector('.nav-item.back');
    tabsContents.forEach((content) => {
          content.style.display = "none";
    });
    tabsButtons.forEach((button) => {
      button.addEventListener("click", function() {
        const item_id = button.getAttribute("aria-controls");
        tabsButtons.forEach((button) => {
           button.style.display = "none";
           button.classList.remove("active");
         })
         tabsContents.forEach((content) => {
          const id = content.getAttribute("id");
          if (item_id === id) {
            scroll_function('#delivery-Subtab');
            button.style.display = "flex";
            button.classList.add("active");
            content.style.display = "block";
            tabsBack.style.display ="flex";
            
          }
        });
      });
    });
    if(tabsBack){
    tabsBack.addEventListener("click", function(){
      tabsContents.forEach((content) => {
           content.style.display = "none";
     })
      tabsButtons.forEach((button) => {
           button.style.display = "block";
           button.classList.remove("active");
         })
      tabsBack.style.display = "none";
    })
    }
    }

  });

//scroll
let header_Height = $('.shopify-section-group-header-group').outerHeight();
function scroll_function(href) {
  $('html, body').animate({
    scrollTop: $(href).offset().top - (header_Height) + 'px'
  }, 500);
  console.log("scrollTop");
}